import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const useSimilarBooks = (bookId, options = {}) => {
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const res = await instance.get(`books/${bookId}/similar?limit=4`);
		return res?.data?.data;
	};

	return useQuery(
		["books", bookId, "similar"],
		() => fetch(),
		{
			...fetchConfig,
			enabled: !!bookId,
			...options,
		}
	);
};

export default useSimilarBooks;
